import React from "react";
import Logo from "../Logo";
import Description from "Portal/Description/View";
import CSSModules from "react-css-modules";
import css from "./style.scss";
import MenuButtons from "../MenuButtons";

import { Default } from "Portal/NewPortal/Shared/MediasQuery";
import { SECTIONS_IDS } from "../../constants";

const Page = ({
  selectedCategory,
  children,
  title,
  description,
  logoImageUrl,
  logoImageAltText,
  backgroundColor,
  backgroundImageUrl,
  backgroundImageAltText,
  style: userStyles = {},
  titleStyle = {},
  enableBackgroundFullWidth
}) => {
  const isHomeSection = SECTIONS_IDS.HOME === selectedCategory;
  return (
    <div
      styleName="wrapper"
      style={{
        backgroundColor: backgroundColor
      }}
    >
      <div
        styleName="header"
        style={
          enableBackgroundFullWidth
            ? {
                backgroundImage: `url(${backgroundImageUrl})`,
                backgroundSize: "100% auto",
                backgroundPosition: "top center",
                backgroundRepeat: "no-repeat",
                height: "260px",
                width: "100%",
                overflow: "hidden"
              }
            : {}
        }
      >
        {enableBackgroundFullWidth ? null : (
          <img
            styleName={
              enableBackgroundFullWidth ? "headerImgFullWidth" : "headerImg"
            }
            src={backgroundImageUrl}
            aria-label={backgroundImageAltText}
            alt={backgroundImageAltText}
          />
        )}
      </div>

      <div styleName="body" style={userStyles}>
        <div styleName="body-header-container">
          <Logo
            logoImageUrl={logoImageUrl}
            logoImageAltText={logoImageAltText}
          />
          {title && title.length && isHomeSection ? (
            <div styleName="title">
              <Description
                instanceId={selectedCategory}
                titleStyle={titleStyle}
                title={title}
                description={description}
              />
            </div>
          ) : null}
        </div>
        <Default>
          <MenuButtons {...{ isHomeSection, selectedCategory }} />
        </Default>
        {children}
      </div>
    </div>
  );
};
export default CSSModules(css)(Page);
